module.exports = __webpack_public_path__ + "img/supervisor-intro-two.719495ab.png";